module.exports = __webpack_public_path__ + "static/media/Dragonboy.e54b73fd.png";